import React, { useState } from 'react'
import { ModalForAll } from '../../components'
import Select from "react-select";
import CallApi from '../../data/CallApi';

const optionSelect = [
    { label: 'Eliminar/Error', value: 'removed' },
    { label: 'Despido', value: 'dismissed' },
    { label: 'Renuncia', value: 'resigned' },
];

export const RemoveUsers = ({
    dataUser,
    closeModal = (() => { }),
    current_branch,
}) => {
    const [objReason, setObjReason] = useState(optionSelect[0]);

    async function removeWorker() {
        const fetch_remove = await CallApi({
            method: 'delete',
            url: `api/company/user/remove?key_branch=${current_branch}`,
            body: {
                user_key: dataUser?.key_user,
                reason: objReason.value
            }
        });

        if (fetch_remove?.code != 200) return;

        closeModal(dataUser?.key_user);
    }

    return (
        <ModalForAll stateModal={Object.keys(dataUser ?? {}).length > 0 ? true : false} setStateModal={() => closeModal({})}>
            <div className='fired-user-container'>
                <h3>Desvincular Usuario</h3>
                <p>Estas a punto de eliminar a <b>{dataUser?.fullName}</b>, ingresa el motivo por favor:</p>

                <div style={{ height: 'min-content', width: '100%' }}>
                    <Select
                        className={'react-select-container'}
                        options={optionSelect}
                        value={objReason}
                        onChange={(e) => setObjReason(e)}

                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                            menuPortal: base => ({ ...base, zIndex: 99 })
                        }}
                    />
                </div>

                <div className='global-modal-footer'>
                    <button className='default-buttons' style={{ '--color-selected': 'var(--color-cancel)' }} onClick={() => closeModal({})}>Cancelar</button>
                    <button className='default-buttons' style={{ '--color-selected': 'var(--color-save)' }} onClick={removeWorker}>Guardar</button>
                </div>
            </div>
        </ModalForAll>
    )
}
